// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrCodePreviewContainer_fK5IS {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 250px;
  min-width: 200px;
  flex-shrink: 0;
  margin: 0 auto;
  position: relative;
  max-height: calc(100vh - 140px);
  min-height: 400px;
  overflow-y: auto;
  overflow-x: visible;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
}

.qrCodePreviewContainer_fK5IS::-webkit-scrollbar {
  display: none;
}



.qrCodeWrapper_n6Kq_ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}




.removeButton_ql4KN {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #ff4d4f;
  color: var(--white-color);
  border: 2px solid var(--white-color);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 1.1rem;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 4px var(--_00000033-shadow);
}

.removeButton_ql4KN:hover {
  background-color: #d9363e;
}

.savedStylesSection_F8n6K {
  width: 100%;
  margin-top: 0;
  padding-top: 0;
  border-top: 1px solid #f0f0f0;
  box-sizing: border-box;
}

.addNewStyleButton_oWvDl {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0px;
  cursor: pointer;
  border: 1px solid var(--f0-border);
  border-radius: 20px;
  padding: 8px 10px;
  width: fit-content;
  box-sizing: border-box;
  background-color: #ffffff;

}

.plusIcon__riSG {
  font-size: 16px;
  color: #666666;
  font-weight: 500;
}

.newStyleText_g5fP_ {
  font-size: 14px;
  color: #333333;
  font-weight: 400;
}

.savedStylesGrid_TCem0 {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
}

.savedStylePreviewContainer_VfXZD {
  position: relative;
  margin-bottom: 8px;
  width: fit-content;
}

.savedStylePreview_Dq95H {
  min-width: 80px;
  min-height: 80px;
  max-width: 100px;
  max-height: 100px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  object-fit: cover;
}

.removeSavedStyleButton_dccsz {
  position: absolute;
  top: -5px;
  right: -5px;
  z-index: 10;
  background-color: #ef4444 !important;
}

.removeSavedStyleButton_dccsz:hover {
  background-color: #dc2626 !important;
}

.selectedRemoveButton_u78Rq {
  background-color: #ef4444 !important;
}

.selectedRemoveButton_u78Rq:hover {
  background-color: #dc2626 !important;
}

.modeToggleSection_xdsjZ {
  width: 100%;
  padding: 14px 0px;
  border-top: 1px solid #f0f0f0;
  box-sizing: border-box;
}

.modeToggleItem_XrdmF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.modeToggleItem_XrdmF:last-child {
  margin-bottom: 0;
}

.modeLabel_gDEFq {
  font-size: 14px;
  color: #333333;
  font-weight: 400;
}

.toggleSwitch_nJeyn {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: #e5e5e5;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
}

.toggleSwitch_nJeyn.toggleActive_ZIczf {
  background-color: #000000;
}

.toggleSlider_RwymJ {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggleActive_ZIczf .toggleSlider_RwymJ {
  transform: translateX(20px);
}

.errorCorrectionSection_BU31h {
  width: 100%;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
  box-sizing: border-box;
}

.sectionTitle_x95NA {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.errorCorrectionContent_n8zoN {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  color: #71717A !important;
}

.errorCorrectionDescription_Ria1p {
  font-size: 10px;
  color: #71717A !important;
  margin: 0;
  line-height: 1.4;
}

@media (max-width: 1200px) {
  .qrCodePreviewContainer_fK5IS {
    max-width: 320px;
    min-width: 280px;
    padding: 14px;
  }

}

@media (max-width: 1024px) {
  .qrCodePreviewContainer_fK5IS {
    max-width: 300px;
    min-width: 260px;
    padding: 12px;
    max-height: calc(100vh - 160px);
    min-height: 350px;
  }


  .savedStylesSection_F8n6K,
  .modeToggleSection_xdsjZ,
  .errorCorrectionSection_BU31h {
    margin-top: 20px;
    padding-top: 16px;
    padding-bottom: 20px;
  }

  .savedStylePreview_Dq95H {
    max-width: 80px;
    max-height: 80px;
  }
}

@media (max-width: 768px) {
  .qrCodePreviewContainer_fK5IS {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0 auto;
    max-height: none;
    min-height: 300px;
    padding: 12px;
    align-self: center;
  }



  .savedStylesSection_F8n6K,
  .modeToggleSection_xdsjZ,
  .errorCorrectionSection_BU31h {
    margin-top: 16px;
    padding-top: 12px;
    padding-bottom: 16px;
  }

  .savedStylesGrid_TCem0 {
    gap: 10px;
  }

  .savedStylePreview_Dq95H {
    max-width: 70px;
    max-height: 70px;
  }

  .addNewStyleButton_oWvDl {
    margin-bottom: 12px;
    margin-top: 8px;
    padding: 12px;
  }

  .plusIcon__riSG {
    font-size: 14px;
  }

  .newStyleText_g5fP_ {
    font-size: 13px;
  }

  .modeToggleItem_XrdmF {
    margin-bottom: 16px;
  }

  .sectionTitle_x95NA {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .modeLabel_gDEFq {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .qrCodePreviewContainer_fK5IS {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 10px;
    max-height: none;
    min-height: 260px;
    margin: 0 auto;
  }


  .savedStylesSection_F8n6K,
  .modeToggleSection_xdsjZ,
  .errorCorrectionSection_BU31h {
    margin-top: 12px;
    padding-top: 8px;
    padding-bottom: 12px;
  }

  .addNewStyleButton_oWvDl {
    margin-bottom: 8px;
    margin-top: 6px;
    padding: 10px;
  }

  .plusIcon__riSG {
    font-size: 12px;
  }

  .newStyleText_g5fP_ {
    font-size: 11px;
  }

  .savedStylesGrid_TCem0 {
    gap: 8px;
  }

  .savedStylePreview_Dq95H {
    max-width: 60px;
    max-height: 60px;
  }

  .sectionTitle_x95NA {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .modeLabel_gDEFq {
    font-size: 12px;
  }

  .modeToggleItem_XrdmF {
    margin-bottom: 12px;
  }

  .toggleSwitch_nJeyn {
    width: 38px;
    height: 20px;
  }

  .toggleSlider_RwymJ {
    width: 16px;
    height: 16px;
  }

  .toggleActive_ZIczf .toggleSlider_RwymJ {
    transform: translateX(18px);
  }

  .errorCorrectionContent_n8zoN {
    gap: 8px;
  }

  .errorCorrectionDescription_Ria1p {
    font-size: 11px;
  }
}

@media (max-width: 375px) {
  .qrCodePreviewContainer_fK5IS {
    width: 100%;
    max-width: 100%;
    padding: 8px;
  }


  .savedStylePreview_Dq95H {
    max-width: 50px;
    max-height: 50px;
  }

  .addNewStyleButton_oWvDl {
    padding: 8px;
  }

  .plusIcon__riSG {
    font-size: 10px;
  }

  .newStyleText_g5fP_ {
    font-size: 10px;
  }
}

@media (max-width: 320px) {
  .qrCodePreviewContainer_fK5IS {
    width: 100%;
    max-width: 100%;
    padding: 6px;
    min-height: 220px;
  }


  .savedStylesSection_F8n6K,
  .modeToggleSection_xdsjZ,
  .errorCorrectionSection_BU31h {
    margin-top: 8px;
    padding-top: 6px;
    padding-bottom: 8px;
  }

  .savedStylePreview_Dq95H {
    max-width: 45px;
    max-height: 45px;
  }

  .sectionTitle_x95NA {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .modeLabel_gDEFq {
    font-size: 11px;
  }

  .toggleSwitch_nJeyn {
    width: 34px;
    height: 18px;
  }

  .toggleSlider_RwymJ {
    width: 14px;
    height: 14px;
  }

  .toggleActive_ZIczf .toggleSlider_RwymJ {
    transform: translateX(16px);
  }
}`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/QRCodePreview/QRCodePreview.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;;;;AAKA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;;AAE3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;EACnB;;;EAGA;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;;;EAIA;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;;EAGA;;;IAGE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;;EAGA;;;IAGE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".qrCodePreviewContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 250px;\n  min-width: 200px;\n  flex-shrink: 0;\n  margin: 0 auto;\n  position: relative;\n  max-height: calc(100vh - 140px);\n  min-height: 400px;\n  overflow-y: auto;\n  overflow-x: visible;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  box-sizing: border-box;\n}\n\n.qrCodePreviewContainer::-webkit-scrollbar {\n  display: none;\n}\n\n\n\n.qrCodeWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n\n\n\n.removeButton {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background-color: #ff4d4f;\n  color: var(--white-color);\n  border: 2px solid var(--white-color);\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  font-size: 1.1rem;\n  line-height: 18px;\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 2px 4px var(--_00000033-shadow);\n}\n\n.removeButton:hover {\n  background-color: #d9363e;\n}\n\n.savedStylesSection {\n  width: 100%;\n  margin-top: 0;\n  padding-top: 0;\n  border-top: 1px solid #f0f0f0;\n  box-sizing: border-box;\n}\n\n.addNewStyleButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0px;\n  cursor: pointer;\n  border: 1px solid var(--f0-border);\n  border-radius: 20px;\n  padding: 8px 10px;\n  width: fit-content;\n  box-sizing: border-box;\n  background-color: #ffffff;\n\n}\n\n.plusIcon {\n  font-size: 16px;\n  color: #666666;\n  font-weight: 500;\n}\n\n.newStyleText {\n  font-size: 14px;\n  color: #333333;\n  font-weight: 400;\n}\n\n.savedStylesGrid {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.savedStylePreviewContainer {\n  position: relative;\n  margin-bottom: 8px;\n  width: fit-content;\n}\n\n.savedStylePreview {\n  min-width: 80px;\n  min-height: 80px;\n  max-width: 100px;\n  max-height: 100px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  object-fit: cover;\n}\n\n.removeSavedStyleButton {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  z-index: 10;\n  background-color: #ef4444 !important;\n}\n\n.removeSavedStyleButton:hover {\n  background-color: #dc2626 !important;\n}\n\n.selectedRemoveButton {\n  background-color: #ef4444 !important;\n}\n\n.selectedRemoveButton:hover {\n  background-color: #dc2626 !important;\n}\n\n.modeToggleSection {\n  width: 100%;\n  padding: 14px 0px;\n  border-top: 1px solid #f0f0f0;\n  box-sizing: border-box;\n}\n\n.modeToggleItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.modeToggleItem:last-child {\n  margin-bottom: 0;\n}\n\n.modeLabel {\n  font-size: 14px;\n  color: #333333;\n  font-weight: 400;\n}\n\n.toggleSwitch {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: #e5e5e5;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  flex-shrink: 0;\n}\n\n.toggleSwitch.toggleActive {\n  background-color: #000000;\n}\n\n.toggleSlider {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggleActive .toggleSlider {\n  transform: translateX(20px);\n}\n\n.errorCorrectionSection {\n  width: 100%;\n  padding-top: 10px;\n  border-top: 1px solid #f0f0f0;\n  box-sizing: border-box;\n}\n\n.sectionTitle {\n  font-size: 16px;\n  color: #333333;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.errorCorrectionContent {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  color: #71717A !important;\n}\n\n.errorCorrectionDescription {\n  font-size: 10px;\n  color: #71717A !important;\n  margin: 0;\n  line-height: 1.4;\n}\n\n@media (max-width: 1200px) {\n  .qrCodePreviewContainer {\n    max-width: 320px;\n    min-width: 280px;\n    padding: 14px;\n  }\n\n}\n\n@media (max-width: 1024px) {\n  .qrCodePreviewContainer {\n    max-width: 300px;\n    min-width: 260px;\n    padding: 12px;\n    max-height: calc(100vh - 160px);\n    min-height: 350px;\n  }\n\n\n  .savedStylesSection,\n  .modeToggleSection,\n  .errorCorrectionSection {\n    margin-top: 20px;\n    padding-top: 16px;\n    padding-bottom: 20px;\n  }\n\n  .savedStylePreview {\n    max-width: 80px;\n    max-height: 80px;\n  }\n}\n\n@media (max-width: 768px) {\n  .qrCodePreviewContainer {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    margin: 0 auto;\n    max-height: none;\n    min-height: 300px;\n    padding: 12px;\n    align-self: center;\n  }\n\n\n\n  .savedStylesSection,\n  .modeToggleSection,\n  .errorCorrectionSection {\n    margin-top: 16px;\n    padding-top: 12px;\n    padding-bottom: 16px;\n  }\n\n  .savedStylesGrid {\n    gap: 10px;\n  }\n\n  .savedStylePreview {\n    max-width: 70px;\n    max-height: 70px;\n  }\n\n  .addNewStyleButton {\n    margin-bottom: 12px;\n    margin-top: 8px;\n    padding: 12px;\n  }\n\n  .plusIcon {\n    font-size: 14px;\n  }\n\n  .newStyleText {\n    font-size: 13px;\n  }\n\n  .modeToggleItem {\n    margin-bottom: 16px;\n  }\n\n  .sectionTitle {\n    font-size: 15px;\n    margin-bottom: 12px;\n  }\n\n  .modeLabel {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .qrCodePreviewContainer {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    padding: 10px;\n    max-height: none;\n    min-height: 260px;\n    margin: 0 auto;\n  }\n\n\n  .savedStylesSection,\n  .modeToggleSection,\n  .errorCorrectionSection {\n    margin-top: 12px;\n    padding-top: 8px;\n    padding-bottom: 12px;\n  }\n\n  .addNewStyleButton {\n    margin-bottom: 8px;\n    margin-top: 6px;\n    padding: 10px;\n  }\n\n  .plusIcon {\n    font-size: 12px;\n  }\n\n  .newStyleText {\n    font-size: 11px;\n  }\n\n  .savedStylesGrid {\n    gap: 8px;\n  }\n\n  .savedStylePreview {\n    max-width: 60px;\n    max-height: 60px;\n  }\n\n  .sectionTitle {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  .modeLabel {\n    font-size: 12px;\n  }\n\n  .modeToggleItem {\n    margin-bottom: 12px;\n  }\n\n  .toggleSwitch {\n    width: 38px;\n    height: 20px;\n  }\n\n  .toggleSlider {\n    width: 16px;\n    height: 16px;\n  }\n\n  .toggleActive .toggleSlider {\n    transform: translateX(18px);\n  }\n\n  .errorCorrectionContent {\n    gap: 8px;\n  }\n\n  .errorCorrectionDescription {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 375px) {\n  .qrCodePreviewContainer {\n    width: 100%;\n    max-width: 100%;\n    padding: 8px;\n  }\n\n\n  .savedStylePreview {\n    max-width: 50px;\n    max-height: 50px;\n  }\n\n  .addNewStyleButton {\n    padding: 8px;\n  }\n\n  .plusIcon {\n    font-size: 10px;\n  }\n\n  .newStyleText {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 320px) {\n  .qrCodePreviewContainer {\n    width: 100%;\n    max-width: 100%;\n    padding: 6px;\n    min-height: 220px;\n  }\n\n\n  .savedStylesSection,\n  .modeToggleSection,\n  .errorCorrectionSection {\n    margin-top: 8px;\n    padding-top: 6px;\n    padding-bottom: 8px;\n  }\n\n  .savedStylePreview {\n    max-width: 45px;\n    max-height: 45px;\n  }\n\n  .sectionTitle {\n    font-size: 13px;\n    margin-bottom: 6px;\n  }\n\n  .modeLabel {\n    font-size: 11px;\n  }\n\n  .toggleSwitch {\n    width: 34px;\n    height: 18px;\n  }\n\n  .toggleSlider {\n    width: 14px;\n    height: 14px;\n  }\n\n  .toggleActive .toggleSlider {\n    transform: translateX(16px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qrCodePreviewContainer": `qrCodePreviewContainer_fK5IS`,
	"qrCodeWrapper": `qrCodeWrapper_n6Kq_`,
	"removeButton": `removeButton_ql4KN`,
	"savedStylesSection": `savedStylesSection_F8n6K`,
	"addNewStyleButton": `addNewStyleButton_oWvDl`,
	"plusIcon": `plusIcon__riSG`,
	"newStyleText": `newStyleText_g5fP_`,
	"savedStylesGrid": `savedStylesGrid_TCem0`,
	"savedStylePreviewContainer": `savedStylePreviewContainer_VfXZD`,
	"savedStylePreview": `savedStylePreview_Dq95H`,
	"removeSavedStyleButton": `removeSavedStyleButton_dccsz`,
	"selectedRemoveButton": `selectedRemoveButton_u78Rq`,
	"modeToggleSection": `modeToggleSection_xdsjZ`,
	"modeToggleItem": `modeToggleItem_XrdmF`,
	"modeLabel": `modeLabel_gDEFq`,
	"toggleSwitch": `toggleSwitch_nJeyn`,
	"toggleActive": `toggleActive_ZIczf`,
	"toggleSlider": `toggleSlider_RwymJ`,
	"errorCorrectionSection": `errorCorrectionSection_BU31h`,
	"sectionTitle": `sectionTitle_x95NA`,
	"errorCorrectionContent": `errorCorrectionContent_n8zoN`,
	"errorCorrectionDescription": `errorCorrectionDescription_Ria1p`
};
export default ___CSS_LOADER_EXPORT___;
